import { getType } from './helpers/typeModifier';
import { reducer, initialStateBase } from './newCollection';

export const TYPE = 'SEO';

export const urls = {
    getTags: module => `/api/seo/tags/${module}`,
    getCTXTags: module => `/api/seo/ctx/tags/${module}`
};

export default (state = initialStateBase, action) => {
    const reducerType = getType(TYPE, action.url);

    switch (action.type) {
        case `RECEIVE_ELEMENT_${TYPE}`:
            return reducer(state, {
                ...action,
                data: {
                    data: {
                        ...action.data.data,
                        id: reducerType
                    }
                }
            }, TYPE);
        default:
            return reducer(state, action, TYPE);
    }
};
